(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const initializeHeroEndScreens = (root = document) => {
    root.querySelectorAll('[data-hero-video-end]').forEach((wrapper) => {
      if (wrapper.dataset.heroVideoEndReady === 'true') return;

      const video = wrapper.querySelector('video');
      if (!video) return;

      wrapper.dataset.heroVideoEndReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');

      const showEndScreen = () => wrapper.setAttribute('data-video-ended', 'true');
      const showVideo = () => wrapper.removeAttribute('data-video-ended');
      const playOnce = () => {
        if (video.ended) return;
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      };

      if (video.ended) {
        showEndScreen();
      } else if (video.readyState >= 2) {
        playOnce();
      } else {
        video.addEventListener('canplay', playOnce, { once: true });
      }

      video.addEventListener('ended', showEndScreen);
      video.addEventListener('play', showVideo);
      window.addEventListener('pageshow', playOnce, { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHeroEndScreens(), { once: true });
  } else {
    initializeHeroEndScreens();
  }

  document.addEventListener('shopify:section:load', (event) => initializeHeroEndScreens(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('reset-share-link')) {
    customElements.define('reset-share-link', class extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-share-button]');
      this.status = this.querySelector('[data-share-status]');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      window.clearTimeout(this.statusTimer);
    }

    async getShareUrl() {
      if (this.dataset.shareMode !== 'cart') return window.location.href;

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Cart request failed');

      const cart = await response.json();
      if (!cart.items.length) throw new Error('Cart is empty');

      const quantities = new Map();
      cart.items.forEach((item) => {
        quantities.set(item.variant_id, (quantities.get(item.variant_id) || 0) + item.quantity);
      });

      const cartPath = Array.from(quantities)
        .map(([variantId, quantity]) => `${variantId}:${quantity}`)
        .join(',');

      const cartUrl = new URL(`${root}cart/${cartPath}`, window.location.origin);
      cartUrl.searchParams.set('storefront', 'true');
      return cartUrl.href;
    }

    async copyUrl(url) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        return;
      }

      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    showStatus(message) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.add('is-visible');
      window.clearTimeout(this.statusTimer);
      this.statusTimer = window.setTimeout(() => {
        this.status.classList.remove('is-visible');
      }, 2600);
    }

    async handleClick() {
      if (!this.button) return;
      this.button.disabled = true;

      try {
        const url = await this.getShareUrl();
        const shareData = {
          title: this.dataset.shareTitle || document.title,
          text: this.dataset.shareText || '',
          url,
        };

        if (navigator.share) {
          try {
            await navigator.share(shareData);
            this.showStatus(this.dataset.shareSuccess || 'Shared');
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }

        await this.copyUrl(url);
        this.showStatus(this.dataset.shareCopied || 'Link copied');
      } catch (error) {
        if (error?.name !== 'AbortError') {
          this.showStatus(this.dataset.shareError || 'Unable to share right now');
        }
      } finally {
        this.button.disabled = false;
      }
    }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reset-seller-admin"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reset-seller-admin')) {
    customElements.define(
      'reset-seller-admin',
      class extends HTMLElement {
        connectedCallback() {
          this.search = this.querySelector('[data-reset-admin-search]');
          this.status = this.querySelector('[data-reset-admin-status]');
          this.rows = Array.from(this.querySelectorAll('[data-reset-admin-row]'));
          this.empty = this.querySelector('[data-reset-admin-empty]');
          this.search?.addEventListener('input', () => this.filterRows());
          this.status?.addEventListener('change', () => this.filterRows());
        }

        filterRows() {
          const query = this.search?.value.trim().toLowerCase() || '';
          const status = this.status?.value || 'all';
          let visible = 0;
          this.rows.forEach((row) => {
            const matchesQuery = !query || row.dataset.search.includes(query);
            const matchesStatus = status === 'all' || row.dataset.status === status;
            row.hidden = !(matchesQuery && matchesStatus);
            if (!row.hidden) visible += 1;
          });
          if (this.empty) this.empty.hidden = visible !== 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seller-portal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reset-seller-dashboard')) {
    customElements.define(
      'reset-seller-dashboard',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-reset-copy-link]').forEach((button) => {
            button.addEventListener('click', async () => {
              const field = this.querySelector('[data-reset-seller-link]');
              if (!field) return;
              try {
                await navigator.clipboard.writeText(field.value);
                const original = button.textContent;
                button.textContent = 'Copied';
                window.setTimeout(() => {
                  button.textContent = original;
                }, 1800);
              } catch (error) {
                field.select();
                document.execCommand('copy');
              }
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-tiered-pricing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wholesale-profit-calculator')) {
    customElements.define(
      'wholesale-profit-calculator',
      class extends HTMLElement {
        connectedCallback() {
          this.results = this.querySelector('[data-results]');
          this.markupInput = this.querySelector('[data-markup]');
          this.markupOutput = this.querySelector('[data-markup-output]');
          this.marginOutput = this.querySelector('[data-margin-output]');
          this.searchInputs = [...this.querySelectorAll('[data-search]')];
          this.sizeSorts = [...this.querySelectorAll('[data-size-sort]')];
          this.tierButtons = [...this.querySelectorAll('[data-tier]')];
          this.searchTerm = '';
          this.sizeSortValue = 'default';
          this.prices = JSON.parse(this.querySelector('[data-wholesale-prices]')?.textContent || '[]');
          this.formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          this.markupInput?.addEventListener('input', this.render);
          this.searchInputs.forEach((input) => input.addEventListener('input', this.handleSearchInput));
          this.sizeSorts.forEach((select) => select.addEventListener('change', this.handleSizeSort));
          this.tierButtons.forEach((button) => button.addEventListener('click', this.handleTierClick));
          this.render();
        }

        disconnectedCallback() {
          this.markupInput?.removeEventListener('input', this.render);
          this.searchInputs?.forEach((input) => input.removeEventListener('input', this.handleSearchInput));
          this.sizeSorts?.forEach((select) => select.removeEventListener('change', this.handleSizeSort));
          this.tierButtons?.forEach((button) => button.removeEventListener('click', this.handleTierClick));
        }

        normalizeSearch = (value) => String(value).toLowerCase().replace(/[^a-z0-9]/g, '');

        handleSearchInput = (event) => {
          this.searchTerm = event.currentTarget.value;
          this.searchInputs.forEach((input) => {
            if (input !== event.currentTarget) input.value = this.searchTerm;
          });
          this.render();
        };

        handleSizeSort = (event) => {
          this.sizeSortValue = event.currentTarget.value;
          this.sizeSorts.forEach((select) => {
            if (select !== event.currentTarget) select.value = this.sizeSortValue;
          });
          this.render();
        };

        handleTierClick = (event) => {
          const selectedTier = event.currentTarget.dataset.tier;
          this.tierButtons.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.tier === selectedTier));
          });
          this.render();
        };

        render = () => {
          if (!this.results) return;

          const adjustment = Number(this.markupInput?.value ?? this.dataset.defaultAdjustment ?? 0);
          const tier = this.tierButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.tier || 'standard';
          const query = this.normalizeSearch(this.searchTerm);
          const sellingPriceMultiplier = 5.2 * (1 + adjustment / 100);
          const margin = ((sellingPriceMultiplier - 1) / sellingPriceMultiplier) * 100;

          if (this.markupOutput) {
            if (adjustment === 0) {
              this.markupOutput.textContent = this.dataset.recommended;
            } else if (adjustment < 0) {
              this.markupOutput.textContent = `${Math.abs(adjustment)}% ${this.dataset.belowRecommended}`;
            } else {
              this.markupOutput.textContent = `${adjustment}% ${this.dataset.aboveRecommended}`;
            }
          }
          if (this.marginOutput) this.marginOutput.textContent = `${margin.toFixed(1)}%`;

          const rows = this.prices.filter(([product]) => !query || this.normalizeSearch(product).includes(query));
          const sizeSort = this.sizeSortValue;
          if (sizeSort !== 'default') {
            rows.sort((first, second) => {
              const productComparison = first[0].localeCompare(second[0]);
              if (productComparison !== 0) return productComparison;
              const firstSize = Number.parseFloat(first[1]) || 0;
              const secondSize = Number.parseFloat(second[1]) || 0;
              return sizeSort === 'ascending' ? firstSize - secondSize : secondSize - firstSize;
            });
          } else if (query) {
            rows.sort((first, second) => {
              const firstProduct = this.normalizeSearch(first[0]);
              const secondProduct = this.normalizeSearch(second[0]);
              const firstScore = firstProduct === query ? 0 : firstProduct.startsWith(query) ? 1 : 2;
              const secondScore = secondProduct === query ? 0 : secondProduct.startsWith(query) ? 1 : 2;
              return firstScore - secondScore;
            });
          }
          const fragment = document.createDocumentFragment();

          rows.forEach(([product, specification, standardPrice, volumePrice]) => {
            const boxPrice = tier === 'volume' ? volumePrice : standardPrice;
            const costPerVial = boxPrice / 10;
            const standardCostPerVial = standardPrice / 10;
            const recommendedSellPrice = standardCostPerVial * 5.2;
            const sellPrice = recommendedSellPrice * (1 + adjustment / 100);
            const profitPerVial = sellPrice - costPerVial;
            const profitPerBox = profitPerVial * 10;
            const row = document.createElement('tr');
            const values = [
              [product, this.dataset.productLabel],
              [specification, this.dataset.specificationLabel],
              [this.formatter.format(boxPrice), this.dataset.boxPriceLabel],
              [this.formatter.format(costPerVial), this.dataset.costLabel],
              [this.formatter.format(sellPrice), this.dataset.sellLabel],
              [this.formatter.format(profitPerVial), this.dataset.profitVialLabel],
              [this.formatter.format(profitPerBox), this.dataset.profitBoxLabel],
            ];

            values.forEach(([value, label]) => {
              const cell = document.createElement('td');
              cell.dataset.label = label;
              cell.textContent = value;
              row.appendChild(cell);
            });
            fragment.appendChild(row);
          });

          if (!rows.length) {
            const row = document.createElement('tr');
            const cell = document.createElement('td');
            cell.colSpan = 7;
            cell.className = 'wholesale-calculator__no-results';
            cell.textContent = this.dataset.noResults;
            row.appendChild(cell);
            fragment.appendChild(row);
          }

          this.results.replaceChildren(fragment);
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
